import { Vue, Component } from 'vue-property-decorator';
import template from './required-field-label.vue';

@Component({
  mixins: [template],
})
export default class RequiredFieldLabel extends Vue {
}
